<template>
  <div
    class="shadow-lg border border-primary-50 dark:text-dark-text dark:bg-dark-800 dark:border-dark-400"
    style="border-radius: 1rem"
  >
    <div
      class="bg-primary-500 border-primary-50 dark:bg-dark-400 dark:border-dark-700"
      style="border-top-right-radius: 1rem; border-top-left-radius: 1rem"
    >
      <div class="commentary-top flex no-select mx-2">
        <div class="flex items-center justify-center text-white dark:text-dark-text">
          <span class="text-2xl material-icons mr-2"> {{ icon }} </span>
          <div class="text-lg font-bold">{{ getTitle(commentary.type) }}</div>
        </div>
        <div class="flex-grow" />
        <DropDown
          class="items-center justify-center"
          :itemList="commentary.filter"
          :selected="selectCommentary"
          :selectedIndex="selectedIndex"
        />
      </div>
    </div>
    <div class="commentary-bottom">
      <div v-bind:id="idBinder(commentary)" class="mb-3" :class="isLightMode() ? 'description' : 'description-dark'" />
      <span class="mr-1" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import DropDown from '@/presentation/components/DropDown/DropDown.vue'
import { useGetCommentaryPresenter } from '@/presentation/composables/commentary/useGetCommentaryPresenter'
import { useConfigStatePresenter } from '@/presentation/composables/config/useConfigStatePresenter'

export default defineComponent({
  components: { DropDown },
  props: {
    icon: {
      type: String,
      required: true
    },
    panelIndex: {
      type: Number,
      required: true
    },
    selectedIndex: {
      type: Number,
      required: true
    },
    commentary: {
      type: Object,
      required: true
    },
    bindCommentary: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const getCommentaryPresenter = useGetCommentaryPresenter()
    const { isLightMode } = useConfigStatePresenter()

    const getTitle = (type: string) => {
      switch (type) {
        case 'general':
          return '一般解説'
        case 'language':
          return '言語解説'
      }
      return type
    }

    const idBinder = (target: any) => {
      return target.pattern + ':' + target.type
    }

    const selectCommentary = (index: number, value: string): void => {
      props.bindCommentary(props.panelIndex, index, value)
    }

    return {
      getTitle,
      idBinder,
      selectCommentary,
      isLightMode,
      getCommentaryPresenter
    }
  }
})
</script>

<style lang="postcss" scoped>
.description {
  & :deep(h1) {
    @apply text-3xl border-b-2 font-medium text-center text-gray-800;
  }

  & :deep(h2) {
    @apply text-xl mt-6 mb-1 border-b-2 text-gray-800 font-medium;
  }

  & :deep(pre) {
    @apply p-3 my-2 rounded border bg-gray-200 whitespace-pre-wrap border-gray-300 text-gray-800;
  }

  & :deep(ul) {
    @apply list-disc pl-12 text-gray-800;
  }

  & :deep(p) {
    @apply my-3 text-gray-800;
  }

  & :deep(a) {
    @apply underline text-blue-500;
  }
}
.description-dark {
  & :deep(h1) {
    @apply text-3xl border-b-2 font-medium text-center text-dark-text border-dark-200;
  }

  & :deep(h2) {
    @apply text-xl mt-6 mb-1 border-b-2 text-dark-text border-dark-200 font-medium;
  }

  & :deep(pre) {
    @apply p-3 my-2 rounded border whitespace-pre-wrap text-dark-text border-dark-200 bg-dark-900;
  }

  & :deep(ul) {
    @apply list-disc pl-12 text-dark-text;
  }

  & :deep(p) {
    @apply my-3 text-dark-text;
  }

  & :deep(a) {
    @apply text-blue-500 underline;
  }
}
.commentary-top {
  padding: 0.7em 1em 0.7em 1em;
}
.commentary-bottom {
  padding: 0.5em 2em 0.7em 2em;
}
</style>
